import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotspot-help',
  templateUrl: './hotspot-help.component.html',
  styleUrls: ['./hotspot-help.component.scss'],
})
export class HotspotHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
